// extracted by mini-css-extract-plugin
module.exports = {"heading":"SiteHeader_heading__QNA7q","header":"SiteHeader_header__kdEB9","btnSignIn":"SiteHeader_btnSignIn__iBli_","user":"SiteHeader_user__lWDG4"};